import {combineReducers} from 'redux';
import Packs from 'routes/Home/Attendance/Stack/Packs/reducers';
import Rules from 'routes/Home/Attendance/Stack/Rules/Module';
import History from 'routes/Home/Attendance/Stack/History/Module';

const reducers = combineReducers({
  Packs,
  History,
  Rules,
});

export default reducers;
